import _ from 'lodash';
import React from 'react';
import approvalStatuses from '~/lookups/approval-statuses';
import MultiSelect from '../MultiSelect';

const options = _.values(approvalStatuses);

export default function ApprovalStatusFilter({ placeholder = 'Approval Status', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
